import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import Christmas from '../../assets/GiftAsset/Christmas.jpg';
import DetailsArrow from '../../assets/GiftAsset/detailsArrow.svg';

const GiftSubHero = () => {
  const navigate = useNavigate()
  return (
    <Box sx={{my:8, backgroundColor:'rgba(231, 225, 211, 1)', display:'block', justifyContent:'space-between', alignItems:'center', borderRadius:'24px', minHeight:'350px', position:'relative'}}>
        <Box sx={{ p:3, width:{xs:'100%', sm:'60%'}, height:'100%'}}>
            <Typography variant='h3'>
            Celebrate the Season of Giving.
            </Typography>
            <Typography sx={{my:3, fontSize:'1.25rem'}}>
            Find the perfect gifts to make this Christmas and New Year unforgettable. Share joy and love with those who matter most.
            </Typography>
            <Typography sx={{my:2, backgroundColor:'rgba(255, 255, 255, 1)', color:'rgba(86, 4, 246, 1)', borderRadius:'12px',width:"62%", p:1, display:{xs:'none', md:'block'}}}>
            Holiday Specials: Up to 30% Off and Free Shipping on Orders Over ₦10,000
            </Typography>
            <Button variant="contained"
              onClick={()=>navigate(`/product/giftshop`)}
                  sx={{width:'25%',display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(246, 167, 4, 1)', py:2, px:2, mt:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:500,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}><span>Shop Holiday Gifts</span><img src={DetailsArrow} alt="details arrow" /></Button>
          <Typography sx={{width:{xs:'100%', sm:'170%'}, zIndex:10, my:2, backgroundColor:'rgba(255, 255, 255, 1)', color:'rgba(86, 4, 246, 1)', borderRadius:'12px', p:1, display:{xs:'block', md:'none', position:"relative", left:0, right:0}}}>
            Holiday Specials: Up to 30% Off and Free Shipping on Orders Over ₦10,000
            </Typography>
        </Box>
        <Box sx={{minHeight:'100%', width:'30%', position:{xs:'relative', sm:'absolute'}, right:0, top:0, backgroundImage:`url(${Christmas})`, backgroundSize:'cover', backgroundRepeat:'no-repeat', backgroundPosition:'center', borderRadius:'0 24px 24px 0'}}>
        </Box>
    </Box>
  )
}

export default GiftSubHero